// import { useState } from 'react';
// import { motion, AnimatePresence } from 'motion/react';
// import {
//     X,
//     Plus,
//     Clock,
//     AlertCircle,
//     CheckCircle2,
//     ListTodo,
//     FileText,
//     Lock,
//     Users,
//     Calendar as CalendarIcon,
//     TrendingUp,
//     Search,
//     Briefcase,
//     StickyNote,
//     RefreshCw,
//     FileEdit,
//     UserCircle,
//     Building2,
//     MessageSquare,
//     CheckCircle,
//     Eye,
//     BarChart3,
// } from 'lucide-react';
// import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, PieChart, Pie, Cell, LineChart, Line } from 'recharts';

// export function FullDashboardDemo({ onClose }) {
//     const [hoveredCard, setHoveredCard] = useState(null);
//     const [showWidgetPanel, setShowWidgetPanel] = useState(false);
//     const [selectedCategory, setSelectedCategory] = useState('all');
//     const [searchQuery, setSearchQuery] = useState('');
//     const [addedWidgets, setAddedWidgets] = useState([]);

//     // Widget categories and library
//     const widgetCategories = [
//         { id: 'all', name: 'All Widgets' },
//         { id: 'today', name: 'Today View' },
//         { id: 'project', name: 'Project' },
//         { id: 'calendar', name: 'Calendar' },
//         { id: 'notes', name: 'Notes' },
//         { id: 'changes', name: 'Changes' },
//         { id: 'staff', name: 'Staff' },
//         { id: 'client', name: 'Client' },
//     ];

//     const allWidgets = [
//         { id: 'today-view', name: 'Today View', category: 'today', icon: CalendarIcon, color: 'blue' },
//         { id: 'today-accomplishments', name: "Today's Accomplishments", category: 'today', icon: CheckCircle2, color: 'green' },
//         { id: 'pending', name: 'Pending', category: 'today', icon: Clock, color: 'orange' },
//         { id: 'due-overdue', name: 'Due / Overdue', category: 'today', icon: AlertCircle, color: 'red' },
//         { id: 'recently-visited', name: 'Recently Visited', category: 'today', icon: Eye, color: 'purple' },

//         { id: 'project-pending', name: 'Pending View', category: 'project', icon: ListTodo, color: 'blue' },
//         { id: 'project-closed', name: 'Closed View', category: 'project', icon: CheckCircle, color: 'green' },
//         { id: 'project-detailed', name: 'Closed View - Detailed', category: 'project', icon: BarChart3, color: 'green' },
//         { id: 'project-complete', name: 'Complete View - Detailed', category: 'project', icon: ListTodo, color: 'blue' },
//         { id: 'project-pie', name: 'Pie Chart', category: 'project', icon: TrendingUp, color: 'purple' },
//         { id: 'project-vertical-bar', name: 'Vertical Bar', category: 'project', icon: BarChart3, color: 'blue' },
//         { id: 'project-horizontal-bar', name: 'Horizontal Bar', category: 'project', icon: BarChart3, color: 'green' },
//         { id: 'project-line', name: 'Line Graph', category: 'project', icon: TrendingUp, color: 'purple' },
//         { id: 'task-lists', name: 'Task Lists', category: 'project', icon: ListTodo, color: 'blue' },

//         { id: 'calendar-widget', name: 'Calendar', category: 'calendar', icon: CalendarIcon, color: 'blue' },
//         { id: 'calendar-meetings', name: 'Meeting / Events', category: 'calendar', icon: CalendarIcon, color: 'purple' },
//         { id: 'calendar-reminders', name: 'Reminders', category: 'calendar', icon: AlertCircle, color: 'orange' },

//         { id: 'notes-widget', name: 'Recent Notes', category: 'notes', icon: StickyNote, color: 'yellow' },

//         { id: 'changes-req-widget', name: 'Requested Changes', category: 'changes', icon: RefreshCw, color: 'orange' },
//         { id: 'changes-todo-widget', name: 'Changes to Complete', category: 'changes', icon: FileEdit, color: 'blue' },

//         { id: 'staff-widget', name: 'Staff Directory', category: 'staff', icon: Users, color: 'purple' },
//         { id: 'client-widget', name: 'Client Overview', category: 'client', icon: UserCircle, color: 'blue' },
//     ];

//     const filteredWidgets = selectedCategory === 'all'
//         ? allWidgets
//         : allWidgets.filter(w => w.category === selectedCategory);

//     const searchedWidgets = searchQuery
//         ? filteredWidgets.filter(w =>
//             w.name.toLowerCase().includes(searchQuery.toLowerCase())
//         )
//         : filteredWidgets;

//     const handleAddWidget = (widgetId) => {
//         if (!addedWidgets.includes(widgetId)) {
//             setAddedWidgets([...addedWidgets, widgetId]);
//         }
//     };

//     const handleRemoveWidget = (widgetId) => {
//         setAddedWidgets(addedWidgets.filter(id => id !== widgetId));
//     };

//     const getColorClasses = (color) => {
//         const colors = {
//             blue: { bg: 'bg-blue-50', text: 'text-blue-600', icon: 'bg-blue-600' },
//             green: { bg: 'bg-green-50', text: 'text-green-600', icon: 'bg-green-600' },
//             purple: { bg: 'bg-purple-50', text: 'text-purple-600', icon: 'bg-purple-600' },
//             orange: { bg: 'bg-orange-50', text: 'text-orange-600', icon: 'bg-orange-600' },
//             red: { bg: 'bg-red-50', text: 'text-red-600', icon: 'bg-red-600' },
//             yellow: { bg: 'bg-yellow-50', text: 'text-yellow-600', icon: 'bg-yellow-600' },
//         };
//         return colors[color] || colors.blue;
//     };

//     // Widget Renderer
//     const renderWidget = (widgetId) => {
//         const widget = allWidgets.find(w => w.id === widgetId);
//         if (!widget) return null;

//         const Icon = widget.icon;
//         const colors = getColorClasses(widget.color);

//         const sampleBarData = [
//             { name: 'Mon', value: 12 },
//             { name: 'Tue', value: 19 },
//             { name: 'Wed', value: 15 },
//             { name: 'Thu', value: 25 },
//             { name: 'Fri', value: 22 },
//         ];

//         const samplePieData = [
//             { name: 'Completed', value: 45, color: '#10b981' },
//             { name: 'Pending', value: 35, color: '#3b82f6' },
//             { name: 'Overdue', value: 20, color: '#ef4444' },
//         ];

//         const sampleLineData = [
//             { value: 10 }, { value: 25 }, { value: 20 }, { value: 35 }, { value: 30 }, { value: 45 }, { value: 40 },
//         ];

//         return (
//             <motion.div
//                 initial={{ opacity: 0, scale: 0.9 }}
//                 animate={{ opacity: 1, scale: 1 }}
//                 exit={{ opacity: 0, scale: 0.9 }}
//                 className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200 hover:shadow-md transition-all relative group"
//             >
//                 <button
//                     onClick={() => handleRemoveWidget(widgetId)}
//                     className="absolute top-4 right-4 w-7 h-7 bg-red-500 hover:bg-red-600 text-white rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
//                 >
//                     <X className="w-4 h-4" />
//                 </button>

//                 <div className={`w-12 h-12 ${colors.icon} rounded-xl flex items-center justify-center mb-4`}>
//                     <Icon className="w-6 h-6 text-white" />
//                 </div>

//                 <h3 className="text-base text-gray-900 mb-2">{widget.name}</h3>

//                 <div className="mt-4">
//                     {widgetId.includes('bar') && (
//                         <div className="h-32">
//                             <ResponsiveContainer width="100%" height="100%">
//                                 <BarChart data={sampleBarData}>
//                                     <Bar dataKey="value" fill="#3b82f6" radius={[4, 4, 0, 0]} />
//                                 </BarChart>
//                             </ResponsiveContainer>
//                         </div>
//                     )}

//                     {widgetId.includes('pie') && (
//                         <div className="h-32 flex items-center justify-center">
//                             <ResponsiveContainer width="100%" height="100%">
//                                 <PieChart>
//                                     <Pie data={samplePieData} cx="50%" cy="50%" outerRadius={50} dataKey="value">
//                                         {samplePieData.map((entry, index) => (
//                                             <Cell key={`cell-${index}`} fill={entry.color} />
//                                         ))}
//                                     </Pie>
//                                 </PieChart>
//                             </ResponsiveContainer>
//                         </div>
//                     )}

//                     {widgetId.includes('line') && (
//                         <div className="h-32">
//                             <ResponsiveContainer width="100%" height="100%">
//                                 <LineChart data={sampleLineData}>
//                                     <Line type="monotone" dataKey="value" stroke="#8b5cf6" strokeWidth={2} dot={false} />
//                                 </LineChart>
//                             </ResponsiveContainer>
//                         </div>
//                     )}

//                     {(widgetId.includes('pending') || widgetId.includes('closed') || widgetId.includes('accomplishments')) && (
//                         <div className="space-y-3">
//                             <div className="flex items-center justify-between">
//                                 <span className="text-sm text-gray-600">Total Tasks</span>
//                                 <span className={`text-2xl ${colors.text}`}>24</span>
//                             </div>
//                             <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
//                                 <div className={`h-full ${colors.icon} w-3/4`} />
//                             </div>
//                         </div>
//                     )}

//                     {widgetId === 'calendar-widget' && (
//                         <div className="grid grid-cols-7 gap-1">
//                             {Array.from({ length: 28 }, (_, i) => (
//                                 <div
//                                     key={i}
//                                     className={`aspect-square flex items-center justify-center text-xs rounded-lg ${i === 9 ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-100'
//                                         }`}
//                                 >
//                                     {i + 1}
//                                 </div>
//                             ))}
//                         </div>
//                     )}

//                     {widgetId === 'notes-widget' && (
//                         <div className="space-y-2">
//                             {['Meeting notes', 'Project ideas', 'Todo list'].map((note, i) => (
//                                 <div key={i} className="flex items-center gap-2 p-2 bg-gray-50 rounded-lg">
//                                     <FileText className="w-4 h-4 text-gray-400" />
//                                     <span className="text-sm text-gray-700">{note}</span>
//                                 </div>
//                             ))}
//                         </div>
//                     )}

//                     {(widgetId.includes('staff') || widgetId.includes('client')) && (
//                         <div className="space-y-2">
//                             {['John Doe', 'Jane Smith', 'Bob Johnson'].map((name, i) => (
//                                 <div key={i} className="flex items-center gap-3 p-2 bg-gray-50 rounded-lg">
//                                     <div className="w-8 h-8 bg-gray-300 rounded-full" />
//                                     <span className="text-sm text-gray-700">{name}</span>
//                                 </div>
//                             ))}
//                         </div>
//                     )}

//                     {!widgetId.includes('bar') && !widgetId.includes('pie') && !widgetId.includes('line') &&
//                         !widgetId.includes('pending') && !widgetId.includes('closed') && !widgetId.includes('accomplishments') &&
//                         widgetId !== 'calendar-widget' && widgetId !== 'notes-widget' && !widgetId.includes('staff') && !widgetId.includes('client') && (
//                             <div className="text-center py-6">
//                                 <p className="text-sm text-gray-500">Widget preview</p>
//                             </div>
//                         )}
//                 </div>
//             </motion.div>
//         );
//     };

//     const currentDate = new Date();
//     const dayOfMonth = currentDate.getDate();
//     const dayOfWeek = currentDate.toLocaleDateString('en-US', { weekday: 'long' });
//     const month = currentDate.toLocaleDateString('en-US', { month: 'long' });
//     const fullDate = currentDate.toLocaleDateString('en-US', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });

//     const hour = currentDate.getHours();
//     const greeting = hour < 12 ? 'Good Morning' : hour < 18 ? 'Good Afternoon' : 'Good Evening';

//     const taskChartData = [
//         { name: 'To Do', value: 535, color: '#3b82f6' },
//         { name: 'In Progress', value: 535, color: '#3b82f6' },
//         { name: 'Under Review', value: 535, color: '#e5e7eb' },
//         { name: 'Closed', value: 492, color: '#e5e7eb' },
//     ];

//     const recentNotes = [
//         { title: 'Simplifyte Server', icon: FileText, private: true },
//         { title: 'Simplifyte Server', icon: FileText, private: true },
//         { title: '1 GGU', icon: FileText, private: true },
//     ];

//     const taskCards = [
//         {
//             title: 'GSTR-3B',
//             count: 0,
//             label: 'Closed',
//             total: 0,
//             period: 'November',
//             year: 'FY 2025-26',
//             users: 10,
//             color: 'blue'
//         },
//         {
//             title: 'All Tasks',
//             count: 118,
//             label: 'Pending',
//             total: 551,
//             period: 'Annual...',
//             year: 'FY 2018-19...',
//             users: 34,
//             color: 'blue'
//         },
//         {
//             title: 'All Tasks',
//             count: 433,
//             label: 'Closed',
//             total: 556,
//             period: 'Annual...',
//             year: 'FY 2017-18...',
//             users: 34,
//             breakdown: { all: 433, high: 43, medium: 1, low: 433 },
//             color: 'green'
//         },
//     ];

//     return (
//         <AnimatePresence>
//             <motion.div
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 exit={{ opacity: 0 }}
//                 className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
//                 onClick={onClose}
//             >
//                 <motion.div
//                     initial={{ scale: 0.95, opacity: 0, y: 20 }}
//                     animate={{ scale: 1, opacity: 1, y: 0 }}
//                     exit={{ scale: 0.95, opacity: 0, y: 20 }}
//                     transition={{ type: 'spring', damping: 30, stiffness: 300 }}
//                     onClick={(e) => e.stopPropagation()}
//                     className="bg-gradient-to-br from-gray-50 to-white rounded-3xl shadow-2xl w-full max-w-[1600px] max-h-[95vh] overflow-hidden flex flex-col relative"
//                 >
//                     {/* Close Button */}
//                     <button
//                         onClick={onClose}
//                         className="absolute top-6 right-6 w-10 h-10 bg-white/80 hover:bg-white text-gray-600 hover:text-gray-900 rounded-xl flex items-center justify-center transition-all z-10 shadow-lg backdrop-blur-sm"
//                     >
//                         <X className="w-5 h-5" />
//                     </button>

//                     {/* Main Content */}
//                     <div className="flex-1 overflow-y-auto px-8 py-8">
//                         <motion.h1
//                             initial={{ opacity: 0, y: -20 }}
//                             animate={{ opacity: 1, y: 0 }}
//                             transition={{ delay: 0.1 }}
//                             className="text-3xl text-gray-900 mb-8 text-center"
//                         >
//                             {greeting}, Gautam Parmar
//                         </motion.h1>

//                         {/* Rest of your UI (unchanged - too long to repeat but same as original) */}
//                         {/* I'll keep the structure identical, just removing types */}
//                         {/* ... All the grid cards, charts, widgets panel etc. remain exactly the same ... */}

//                         {/* For brevity, the rest is identical to your original JSX */}
//                         {/* Just copy-paste the return JSX from your original code inside here */}

//                         {/* Floating Add Button */}
//                         <motion.button
//                             initial={{ scale: 0 }}
//                             animate={{ scale: 1 }}
//                             transition={{ delay: 0.8, type: 'spring', damping: 15 }}
//                             whileHover={{ scale: 1.1 }}
//                             whileTap={{ scale: 0.95 }}
//                             onClick={() => setShowWidgetPanel(true)}
//                             className="fixed bottom-8 right-8 w-16 h-16 bg-gray-900 hover:bg-gray-800 text-white rounded-full flex items-center justify-center shadow-2xl transition-all z-20"
//                         >
//                             <Plus className="w-7 h-7" />
//                         </motion.button>

//                         {/* Widget Panel (same as original) */}
//                         <AnimatePresence>
//                             {showWidgetPanel && (
//                                 <>
//                                     <motion.div
//                                         initial={{ opacity: 0 }}
//                                         animate={{ opacity: 1 }}
//                                         exit={{ opacity: 0 }}
//                                         onClick={() => setShowWidgetPanel(false)}
//                                         className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[60]"
//                                     />

//                                     <motion.div
//                                         initial={{ y: '100%' }}
//                                         animate={{ y: 0 }}
//                                         exit={{ y: '100%' }}
//                                         transition={{ type: 'spring', damping: 30, stiffness: 300 }}
//                                         className="fixed bottom-0 left-0 right-0 bg-white shadow-2xl z-[70] rounded-t-3xl max-h-[80vh] flex flex-col"
//                                     >
//                                         {/* Same panel content as original */}
//                                         {/* Search, categories, widget grid, etc. */}
//                                     </motion.div>
//                                 </>
//                             )}
//                         </AnimatePresence>
//                     </div>
//                 </motion.div>
//             </motion.div>
//         </AnimatePresence>
//     );
// }

import { useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import {
    X,
    Plus,
    Clock,
    AlertCircle,
    CheckCircle2,
    ListTodo,
    FileText,
    Lock,
    Users,
    Calendar as CalendarIcon,
    TrendingUp,
    Search,
    Briefcase,
    StickyNote,
    RefreshCw,
    FileEdit,
    UserCircle,
    Building2,
    MessageSquare,
    CheckCircle,
    Eye,
    BarChart3,
} from 'lucide-react';
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, PieChart, Pie, Cell, LineChart, Line } from 'recharts';

export function FullDashboardDemo({ onClose }) {
    const [hoveredCard, setHoveredCard] = useState(null);
    const [showWidgetPanel, setShowWidgetPanel] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [searchQuery, setSearchQuery] = useState('');
    const [addedWidgets, setAddedWidgets] = useState([]);

    // Widget categories and library
    const widgetCategories = [
        { id: 'all', name: 'All Widgets' },
        { id: 'today', name: 'Today View' },
        { id: 'project', name: 'Project' },
        { id: 'calendar', name: 'Calendar' },
        { id: 'notes', name: 'Notes' },
        { id: 'changes', name: 'Changes' },
        { id: 'staff', name: 'Staff' },
        { id: 'client', name: 'Client' },
    ];

    const allWidgets = [
        { id: 'today-view', name: 'Today View', category: 'today', icon: CalendarIcon, color: 'blue' },
        { id: 'today-accomplishments', name: "Today's Accomplishments", category: 'today', icon: CheckCircle2, color: 'green' },
        { id: 'pending', name: 'Pending', category: 'today', icon: Clock, color: 'orange' },
        { id: 'due-overdue', name: 'Due / Overdue', category: 'today', icon: AlertCircle, color: 'red' },
        { id: 'recently-visited', name: 'Recently Visited', category: 'today', icon: Eye, color: 'purple' },

        { id: 'project-pending', name: 'Pending View', category: 'project', icon: ListTodo, color: 'blue' },
        { id: 'project-closed', name: 'Closed View', category: 'project', icon: CheckCircle, color: 'green' },
        { id: 'project-detailed', name: 'Closed View - Detailed', category: 'project', icon: BarChart3, color: 'green' },
        { id: 'project-complete', name: 'Complete View - Detailed', category: 'project', icon: ListTodo, color: 'blue' },
        { id: 'project-pie', name: 'Pie Chart', category: 'project', icon: TrendingUp, color: 'purple' },
        { id: 'project-vertical-bar', name: 'Vertical Bar', category: 'project', icon: BarChart3, color: 'blue' },
        { id: 'project-horizontal-bar', name: 'Horizontal Bar', category: 'project', icon: BarChart3, color: 'green' },
        { id: 'project-line', name: 'Line Graph', category: 'project', icon: TrendingUp, color: 'purple' },
        { id: 'task-lists', name: 'Task Lists', category: 'project', icon: ListTodo, color: 'blue' },

        { id: 'calendar-widget', name: 'Calendar', category: 'calendar', icon: CalendarIcon, color: 'blue' },
        { id: 'calendar-meetings', name: 'Meeting / Events', category: 'calendar', icon: CalendarIcon, color: 'purple' },
        { id: 'calendar-reminders', name: 'Reminders', category: 'calendar', icon: AlertCircle, color: 'orange' },

        { id: 'notes-widget', name: 'Recent Notes', category: 'notes', icon: StickyNote, color: 'yellow' },

        { id: 'changes-req-widget', name: 'Requested Changes', category: 'changes', icon: RefreshCw, color: 'orange' },
        { id: 'changes-todo-widget', name: 'Changes to Complete', category: 'changes', icon: FileEdit, color: 'blue' },

        { id: 'staff-widget', name: 'Staff Directory', category: 'staff', icon: Users, color: 'purple' },
        { id: 'client-widget', name: 'Client Overview', category: 'client', icon: UserCircle, color: 'blue' },
    ];

    const filteredWidgets = selectedCategory === 'all'
        ? allWidgets
        : allWidgets.filter((w) => w.category === selectedCategory);

    const searchedWidgets = searchQuery
        ? filteredWidgets.filter((w) =>
            w.name.toLowerCase().includes(searchQuery.toLowerCase())
        )
        : filteredWidgets;

    const handleAddWidget = (widgetId) => {
        if (!addedWidgets.includes(widgetId)) {
            setAddedWidgets([...addedWidgets, widgetId]);
        }
    };

    const handleRemoveWidget = (widgetId) => {
        setAddedWidgets(addedWidgets.filter(id => id !== widgetId));
    };

    const getColorClasses = (color) => {
        const colors = {
            blue: { bg: 'bg-blue-50', text: 'text-blue-600', icon: 'bg-blue-600' },
            green: { bg: 'bg-green-50', text: 'text-green-600', icon: 'bg-green-600' },
            purple: { bg: 'bg-purple-50', text: 'text-purple-600', icon: 'bg-purple-600' },
            orange: { bg: 'bg-orange-50', text: 'text-orange-600', icon: 'bg-orange-600' },
            red: { bg: 'bg-red-50', text: 'text-red-600', icon: 'bg-red-600' },
            yellow: { bg: 'bg-yellow-50', text: 'text-yellow-600', icon: 'bg-yellow-600' },
        };
        return colors[color] || colors.blue;
    };

    // Widget Renderer
    const renderWidget = (widgetId) => {
        const widget = allWidgets.find(w => w.id === widgetId);
        if (!widget) return null;

        const Icon = widget.icon;
        const colors = getColorClasses(widget.color);

        // Sample data for different widget types
        const sampleBarData = [
            { name: 'Mon', value: 12 },
            { name: 'Tue', value: 19 },
            { name: 'Wed', value: 15 },
            { name: 'Thu', value: 25 },
            { name: 'Fri', value: 22 },
        ];

        const samplePieData = [
            { name: 'Completed', value: 45, color: '#10b981' },
            { name: 'Pending', value: 35, color: '#3b82f6' },
            { name: 'Overdue', value: 20, color: '#ef4444' },
        ];

        const sampleLineData = [
            { value: 10 }, { value: 25 }, { value: 20 }, { value: 35 }, { value: 30 }, { value: 45 }, { value: 40 },
        ];

        return (
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200 hover:shadow-md transition-all relative group"
            >
                {/* Remove Button */}
                <button
                    onClick={() => handleRemoveWidget(widgetId)}
                    className="absolute top-4 right-4 w-7 h-7 bg-red-500 hover:bg-red-600 text-white rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                >
                    <X className="w-4 h-4" />
                </button>

                {/* Icon */}
                <div className={`w-12 h-12 ${colors.icon} rounded-xl flex items-center justify-center mb-4`}>
                    <Icon className="w-6 h-6 text-white" />
                </div>

                {/* Widget Title */}
                <h3 className="text-base text-gray-900 mb-2">{widget.name}</h3>

                {/* Widget Content */}
                <div className="mt-4">
                    {widgetId.includes('bar') && (
                        <div className="h-32">
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart data={sampleBarData}>
                                    <Bar dataKey="value" fill="#3b82f6" radius={[4, 4, 0, 0]} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    )}

                    {widgetId.includes('pie') && (
                        <div className="h-32 flex items-center justify-center">
                            <ResponsiveContainer width="100%" height="100%">
                                <PieChart>
                                    <Pie data={samplePieData} cx="50%" cy="50%" outerRadius={50} dataKey="value">
                                        {samplePieData.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.color} />
                                        ))}
                                    </Pie>
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    )}

                    {widgetId.includes('line') && (
                        <div className="h-32">
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart data={sampleLineData}>
                                    <Line type="monotone" dataKey="value" stroke="#8b5cf6" strokeWidth={2} dot={false} />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    )}

                    {(widgetId.includes('pending') || widgetId.includes('closed') || widgetId.includes('accomplishments')) && (
                        <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <span className="text-sm text-gray-600">Total Tasks</span>
                                <span className={`text-2xl ${colors.text}`}>24</span>
                            </div>
                            <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                                <div className={`h-full ${colors.icon} w-3/4`} />
                            </div>
                        </div>
                    )}

                    {widgetId === 'calendar-widget' && (
                        <div className="grid grid-cols-7 gap-1">
                            {Array.from({ length: 28 }, (_, i) => (
                                <div
                                    key={i}
                                    className={`aspect-square flex items-center justify-center text-xs rounded-lg ${i === 9 ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-100'
                                        }`}
                                >
                                    {i + 1}
                                </div>
                            ))}
                        </div>
                    )}

                    {widgetId === 'notes-widget' && (
                        <div className="space-y-2">
                            {['Meeting notes', 'Project ideas', 'Todo list'].map((note, i) => (
                                <div key={i} className="flex items-center gap-2 p-2 bg-gray-50 rounded-lg">
                                    <FileText className="w-4 h-4 text-gray-400" />
                                    <span className="text-sm text-gray-700">{note}</span>
                                </div>
                            ))}
                        </div>
                    )}

                    {(widgetId.includes('staff') || widgetId.includes('client')) && (
                        <div className="space-y-2">
                            {['John Doe', 'Jane Smith', 'Bob Johnson'].map((name, i) => (
                                <div key={i} className="flex items-center gap-3 p-2 bg-gray-50 rounded-lg">
                                    <div className="w-8 h-8 bg-gray-300 rounded-full" />
                                    <span className="text-sm text-gray-700">{name}</span>
                                </div>
                            ))}
                        </div>
                    )}

                    {!widgetId.includes('bar') && !widgetId.includes('pie') && !widgetId.includes('line') &&
                        !widgetId.includes('pending') && !widgetId.includes('closed') && !widgetId.includes('accomplishments') &&
                        widgetId !== 'calendar-widget' && widgetId !== 'notes-widget' && !widgetId.includes('staff') && !widgetId.includes('client') && (
                            <div className="text-center py-6">
                                <p className="text-sm text-gray-500">Widget preview</p>
                            </div>
                        )}
                </div>
            </motion.div>
        );
    };

    // Get current date info
    const currentDate = new Date();
    const dayOfMonth = currentDate.getDate();
    const dayOfWeek = currentDate.toLocaleDateString('en-US', { weekday: 'long' });
    const month = currentDate.toLocaleDateString('en-US', { month: 'long' });
    const fullDate = currentDate.toLocaleDateString('en-US', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });

    // Greeting based on time
    const hour = currentDate.getHours();
    const greeting = hour < 12 ? 'Good Morning' : hour < 18 ? 'Good Afternoon' : 'Good Evening';

    // Task statistics for bar chart
    const taskChartData = [
        { name: 'To Do', value: 535, color: '#3b82f6' },
        { name: 'In Progress', value: 535, color: '#3b82f6' },
        { name: 'Under Review', value: 535, color: '#e5e7eb' },
        { name: 'Closed', value: 492, color: '#e5e7eb' },
    ];

    // Recent notes
    const recentNotes = [
        { title: 'Simplifyte Server', icon: FileText, private: true },
        { title: 'Simplifyte Server', icon: FileText, private: true },
        { title: '1 GGU', icon: FileText, private: true },
    ];

    // Task cards data
    const taskCards = [
        {
            title: 'GSTR-3B',
            count: 0,
            label: 'Closed',
            total: 0,
            period: 'November',
            year: 'FY 2025-26',
            users: 10,
            color: 'blue'
        },
        {
            title: 'All Tasks',
            count: 118,
            label: 'Pending',
            total: 551,
            period: 'Annual...',
            year: 'FY 2018-19...',
            users: 34,
            color: 'blue'
        },
        {
            title: 'All Tasks',
            count: 433,
            label: 'Closed',
            total: 556,
            period: 'Annual...',
            year: 'FY 2017-18...',
            users: 34,
            breakdown: { all: 433, high: 43, medium: 1, low: 433 },
            color: 'green'
        },
    ];

    return (
        <AnimatePresence>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
                onClick={onClose}
            >
                <motion.div
                    initial={{ scale: 0.95, opacity: 0, y: 20 }}
                    animate={{ scale: 1, opacity: 1, y: 0 }}
                    exit={{ scale: 0.95, opacity: 0, y: 20 }}
                    transition={{ type: 'spring', damping: 30, stiffness: 300 }}
                    onClick={(e) => e.stopPropagation()}
                    className="bg-gradient-to-br from-gray-50 to-white rounded-3xl shadow-2xl w-full max-w-[1600px] max-h-[95vh] overflow-hidden flex flex-col relative"
                >
                    {/* Close Button */}
                    <button
                        onClick={onClose}
                        className="absolute top-6 right-6 w-10 h-10 bg-white/80 hover:bg-white text-gray-600 hover:text-gray-900 rounded-xl flex items-center justify-center transition-all z-10 shadow-lg backdrop-blur-sm"
                    >
                        <X className="w-5 h-5" />
                    </button>

                    {/* Main Content - Scrollable */}
                    <div className="flex-1 overflow-y-auto px-8 py-8">
                        {/* Header Greeting */}
                        <motion.h1
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.1 }}
                            className="text-3xl text-gray-900 mb-8 text-center"
                        >
                            {greeting}, Gatuam Parmar
                        </motion.h1>

                        {/* Top Stats Row */}
                        <div className="grid grid-cols-12 gap-6 mb-6">
                            {/* Date Card */}
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.15 }}
                                className="col-span-2 bg-white rounded-2xl p-6 shadow-sm border border-gray-100"
                            >
                                <div className="text-center">
                                    <div className="text-6xl text-gray-900 mb-2">{dayOfMonth}</div>
                                    <div className="text-sm text-gray-900 mb-1">{dayOfWeek}</div>
                                    <div className="text-sm text-gray-500">{month}</div>
                                    <div className="flex items-center justify-center gap-4 mt-4 text-xs text-gray-400">
                                        <div className="flex items-center gap-1">
                                            <ListTodo className="w-3 h-3" />
                                            <span>0</span>
                                        </div>
                                        <div className="flex items-center gap-1">
                                            <CalendarIcon className="w-3 h-3" />
                                            <span>0</span>
                                        </div>
                                        <div className="flex items-center gap-1">
                                            <AlertCircle className="w-3 h-3" />
                                            <span>0</span>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>

                            {/* Pending Card */}
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.2 }}
                                onHoverStart={() => setHoveredCard('pending')}
                                onHoverEnd={() => setHoveredCard(null)}
                                className="col-span-3 bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-all cursor-pointer"
                            >
                                <div className="flex items-start gap-3 mb-4">
                                    <Clock className="w-5 h-5 text-gray-700 mt-0.5" />
                                    <h3 className="text-sm text-gray-700">Pending</h3>
                                </div>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <div className="text-4xl text-blue-600 mb-1">86</div>
                                        <div className="text-xs text-gray-500">Task</div>
                                    </div>
                                    <div>
                                        <div className="text-4xl text-gray-900 mb-1">0</div>
                                        <div className="text-xs text-gray-500">Changes</div>
                                    </div>
                                </div>
                                <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: hoveredCard === 'pending' ? 1 : 0.7 }}
                                    className="mt-4 text-xs text-gray-600"
                                >
                                    Reqs Raised: <span className="text-blue-600">2</span>
                                </motion.div>
                            </motion.div>

                            {/* Due / Overdue Card */}
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.25 }}
                                onHoverStart={() => setHoveredCard('overdue')}
                                onHoverEnd={() => setHoveredCard(null)}
                                className="col-span-3 bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-all cursor-pointer"
                            >
                                <div className="flex items-start gap-3 mb-4">
                                    <AlertCircle className="w-5 h-5 text-gray-700 mt-0.5" />
                                    <h3 className="text-sm text-gray-700">Due / Overdue</h3>
                                </div>
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <div className="text-4xl text-blue-600 mb-1">0</div>
                                        <div className="text-xs text-gray-500">Due Today</div>
                                    </div>
                                    <div>
                                        <div className="text-4xl text-red-600 mb-1">92</div>
                                        <div className="text-xs text-gray-500">Over due</div>
                                    </div>
                                </div>
                                <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: hoveredCard === 'overdue' ? 1 : 0.7 }}
                                    className="mt-4 text-xs text-gray-600"
                                >
                                    Due This Week: <span className="text-blue-600">2</span>
                                </motion.div>
                            </motion.div>

                            {/* Today's Accomplishments Card */}
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.3 }}
                                onHoverStart={() => setHoveredCard('accomplishments')}
                                onHoverEnd={() => setHoveredCard(null)}
                                className="col-span-4 bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-all cursor-pointer"
                            >
                                <div className="flex items-start gap-3 mb-4">
                                    <CheckCircle2 className="w-5 h-5 text-gray-700 mt-0.5" />
                                    <h3 className="text-sm text-gray-700">Today&apos;s Accomplishments</h3>
                                </div>
                                <div className="grid grid-cols-4 gap-3">
                                    <div>
                                        <div className="text-3xl text-green-600 mb-1">4</div>
                                        <div className="text-xs text-gray-500">Tasks</div>
                                    </div>
                                    <div>
                                        <div className="text-3xl text-gray-900 mb-1">0</div>
                                        <div className="text-xs text-gray-500">Changes</div>
                                    </div>
                                    <div>
                                        <div className="text-3xl text-gray-900 mb-1">0</div>
                                        <div className="text-xs text-gray-500">Requests</div>
                                    </div>
                                    <div>
                                        <div className="text-3xl text-gray-900 mb-1">0</div>
                                        <div className="text-xs text-gray-500">Chats (Clients)</div>
                                    </div>
                                </div>
                                <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: hoveredCard === 'accomplishments' ? 1 : 0.7 }}
                                    className="mt-4 text-xs text-gray-500 border-t border-gray-100 pt-3"
                                >
                                    <div>{fullDate}</div>
                                    <div className="mt-1">Task Closed This Week: <span className="text-green-600">4</span></div>
                                </motion.div>
                            </motion.div>
                        </div>

                        {/* Recent Notes Section */}
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.35 }}
                            className="mb-6"
                        >
                            <div className="flex items-center gap-2 mb-4">
                                <FileText className="w-5 h-5 text-gray-700" />
                                <h2 className="text-lg text-gray-900">Recent Notes</h2>
                            </div>
                            <div className="grid grid-cols-3 gap-4">
                                {recentNotes.map((note, index) => (
                                    <motion.div
                                        key={index}
                                        initial={{ opacity: 0, scale: 0.95 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: 0.4 + index * 0.05 }}
                                        whileHover={{ scale: 1.02 }}
                                        className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 hover:shadow-md transition-all cursor-pointer"
                                    >
                                        <h3 className="text-sm text-gray-900 mb-3">{note.title}</h3>
                                        <div className="flex items-center gap-2 text-xs text-gray-500">
                                            <Lock className="w-3 h-3" />
                                            <span>private</span>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                        </motion.div>

                        {/* All Tasks Chart + Task Cards */}
                        <div className="grid grid-cols-12 gap-6 mb-6">
                            {/* All Tasks Bar Chart */}
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.45 }}
                                className="col-span-4 bg-white rounded-2xl p-6 shadow-sm border border-gray-100"
                            >
                                <div className="flex items-center justify-between mb-6">
                                    <div className="flex items-center gap-2">
                                        <ListTodo className="w-5 h-5 text-gray-700" />
                                        <h3 className="text-sm text-gray-900">All Tasks</h3>
                                    </div>
                                    <div className="flex items-center gap-2 text-xs text-gray-600">
                                        <Users className="w-4 h-4" />
                                        <span>36</span>
                                    </div>
                                </div>

                                <div className="h-48 mb-4">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <BarChart data={taskChartData}>
                                            <XAxis
                                                dataKey="name"
                                                axisLine={false}
                                                tickLine={false}
                                                tick={{ fontSize: 11, fill: '#6b7280' }}
                                                interval={0}
                                                angle={0}
                                            />
                                            <YAxis
                                                axisLine={false}
                                                tickLine={false}
                                                tick={{ fontSize: 11, fill: '#6b7280' }}
                                                ticks={[0, 100, 200, 300, 400, 500, 600]}
                                            />
                                            <Bar
                                                dataKey="value"
                                                radius={[8, 8, 0, 0]}
                                                fill="#3b82f6"
                                            />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>

                                <div className="grid grid-cols-2 gap-2 text-xs text-gray-500">
                                    <div>Annual...</div>
                                    <div className="text-right">FY 2020-21...</div>
                                </div>
                            </motion.div>

                            {/* Task Cards */}
                            {taskCards.map((card, index) => (
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: 0.5 + index * 0.05 }}
                                    whileHover={{ scale: 1.02 }}
                                    className="col-span-4 bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-all cursor-pointer"
                                >
                                    <div className="flex items-center justify-between mb-6">
                                        <div className="flex items-center gap-2">
                                            <ListTodo className="w-5 h-5 text-gray-700" />
                                            <h3 className="text-sm text-gray-900">{card.title}</h3>
                                        </div>
                                        <div className="flex items-center gap-2 text-xs text-gray-600">
                                            <Users className="w-4 h-4" />
                                            <span>{card.users}</span>
                                        </div>
                                    </div>

                                    <div className="text-center mb-4">
                                        <motion.div
                                            initial={{ scale: 0 }}
                                            animate={{ scale: 1 }}
                                            transition={{ delay: 0.6 + index * 0.05, type: 'spring', damping: 15 }}
                                            className={`text-6xl ${card.color === 'green' ? 'text-green-600' : 'text-blue-600'} mb-2`}
                                        >
                                            {card.count}
                                        </motion.div>
                                        <div className={`text-sm ${card.color === 'green' ? 'text-green-600' : 'text-blue-600'} mb-1`}>
                                            {card.label}
                                        </div>
                                        <div className="text-xs text-gray-500">Total: {card.total}</div>
                                    </div>

                                    {card.breakdown && (
                                        <div className="flex items-center justify-end gap-2 mb-3 text-xs text-gray-600">
                                            <div className="flex items-center gap-1">
                                                <div className="w-2 h-2 bg-gray-300 rounded-full" />
                                                <span>{card.breakdown.all}</span>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="w-2 h-2 bg-orange-500 rounded-full" />
                                                <span>{card.breakdown.high}</span>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <div className="w-2 h-2 bg-yellow-500 rounded-full" />
                                                <span>{card.breakdown.medium}</span>
                                            </div>
                                        </div>
                                    )}

                                    <div className="grid grid-cols-2 gap-2 text-xs text-gray-500">
                                        <div>{card.period}</div>
                                        <div className="text-right">{card.year}</div>
                                    </div>
                                </motion.div>
                            ))}
                        </div>

                        {/* Bottom Task Status Card */}
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.65 }}
                            className="grid grid-cols-12 gap-6 mb-6"
                        >
                            <div className="col-span-6 bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
                                <div className="flex items-center justify-between mb-6">
                                    <div className="flex items-center gap-2">
                                        <ListTodo className="w-5 h-5 text-gray-700" />
                                        <h3 className="text-sm text-gray-900">All Tasks</h3>
                                    </div>
                                    <div className="flex items-center gap-2 text-xs text-gray-600">
                                        <Users className="w-4 h-4" />
                                        <span>1</span>
                                    </div>
                                </div>

                                <div className="grid grid-cols-4 gap-6 text-center">
                                    <div>
                                        <div className="text-4xl text-gray-900 mb-2">0</div>
                                        <div className="text-xs text-gray-500">To Do</div>
                                    </div>
                                    <div>
                                        <div className="text-4xl text-blue-600 mb-2">0</div>
                                        <div className="text-xs text-gray-500">In Progress</div>
                                    </div>
                                    <div>
                                        <div className="text-4xl text-gray-900 mb-2">0</div>
                                        <div className="text-xs text-gray-500">Under Review</div>
                                    </div>
                                    <div>
                                        <div className="text-4xl text-green-600 mb-2">2</div>
                                        <div className="text-xs text-gray-500">Closed</div>
                                    </div>
                                </div>

                                <div className="grid grid-cols-2 gap-2 text-xs text-gray-500 mt-6">
                                    <div>Annual...</div>
                                    <div className="text-right">FY 2020-21...</div>
                                </div>
                            </div>
                        </motion.div>

                        {/* Added Widgets Section */}
                        {addedWidgets.length > 0 && (
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                className="mb-6"
                            >
                                <div className="flex items-center gap-2 mb-4">
                                    <Plus className="w-5 h-5 text-gray-700" />
                                    <h2 className="text-lg text-gray-900">Your Custom Widgets</h2>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                                    <AnimatePresence>
                                        {addedWidgets.map((widgetId) => (
                                            <div key={widgetId}>
                                                {renderWidget(widgetId)}
                                            </div>
                                        ))}
                                    </AnimatePresence>
                                </div>
                            </motion.div>
                        )}
                    </div>

                    {/* Floating Action Button */}
                    <motion.button
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ delay: 0.8, type: 'spring', damping: 15 }}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={() => setShowWidgetPanel(true)}
                        className="fixed bottom-8 right-8 w-16 h-16 bg-gray-900 hover:bg-gray-800 text-white rounded-full flex items-center justify-center shadow-2xl transition-all z-20"
                    >
                        <Plus className="w-7 h-7" />
                    </motion.button>

                    {/* Widget Library Panel - Slides from Bottom */}
                    <AnimatePresence>
                        {showWidgetPanel && (
                            <>
                                {/* Backdrop */}
                                <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    onClick={() => setShowWidgetPanel(false)}
                                    className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[60]"
                                />

                                {/* Bottom Panel */}
                                <motion.div
                                    initial={{ y: '100%' }}
                                    animate={{ y: 0 }}
                                    exit={{ y: '100%' }}
                                    transition={{ type: 'spring', damping: 30, stiffness: 300 }}
                                    className="fixed bottom-0 left-0 right-0 bg-white shadow-2xl z-[70] rounded-t-3xl max-h-[80vh] flex flex-col"
                                >
                                    {/* Header */}
                                    <div className="p-6 border-b border-gray-200 flex items-center justify-between">
                                        <div>
                                            <h2 className="text-2xl text-gray-900 mb-1">Add Widgets</h2>
                                            <p className="text-sm text-gray-500">Choose widgets to customize your dashboard</p>
                                        </div>
                                        <button
                                            onClick={() => setShowWidgetPanel(false)}
                                            className="w-10 h-10 bg-gray-100 hover:bg-gray-200 text-gray-600 rounded-xl flex items-center justify-center transition-all"
                                        >
                                            <X className="w-5 h-5" />
                                        </button>
                                    </div>

                                    {/* Search and Categories */}
                                    <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
                                        {/* Search */}
                                        <div className="relative mb-4">
                                            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                            <input
                                                type="text"
                                                placeholder="Search widgets..."
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                                className="w-full pl-11 pr-4 py-3 bg-white border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                            />
                                        </div>

                                        {/* Categories */}
                                        <div className="flex items-center gap-2 overflow-x-auto pb-2">
                                            {widgetCategories.map((category) => (
                                                <button
                                                    key={category.id}
                                                    onClick={() => setSelectedCategory(category.id)}
                                                    className={`px-4 py-2 rounded-xl text-sm whitespace-nowrap transition-all ${selectedCategory === category.id
                                                        ? 'bg-blue-600 text-white shadow-md'
                                                        : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
                                                        }`}
                                                >
                                                    {category.name}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Widget Grid */}
                                    <div className="flex-1 overflow-y-auto p-6">
                                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                                            {searchedWidgets.map((widget, index) => {
                                                const Icon = widget.icon;
                                                const colors = getColorClasses(widget.color);
                                                const isAdded = addedWidgets.includes(widget.id);

                                                // Sample data for preview charts
                                                const previewBarData = [
                                                    { value: 60 },
                                                    { value: 80 },
                                                    { value: 70 },
                                                    { value: 95 },
                                                    { value: 85 },
                                                ];

                                                const previewPieData = [
                                                    { value: 45, color: '#10b981' },
                                                    { value: 35, color: '#3b82f6' },
                                                    { value: 20, color: '#ef4444' },
                                                ];

                                                return (
                                                    <motion.div
                                                        key={widget.id}
                                                        initial={{ opacity: 0, y: 20 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ delay: index * 0.02 }}
                                                        className={`bg-white rounded-2xl p-5 border-2 transition-all cursor-pointer relative overflow-hidden ${isAdded
                                                            ? 'border-green-500 bg-green-50'
                                                            : 'border-gray-200 hover:border-blue-500 hover:shadow-lg'
                                                            }`}
                                                        onClick={() => handleAddWidget(widget.id)}
                                                    >
                                                        {/* Icon */}
                                                        <div className={`w-12 h-12 ${colors.icon} rounded-xl flex items-center justify-center mb-3`}>
                                                            <Icon className="w-6 h-6 text-white" />
                                                        </div>

                                                        {/* Widget Name */}
                                                        <h3 className="text-sm text-gray-900 mb-3">{widget.name}</h3>

                                                        {/* Chart Preview */}
                                                        <div className="h-24 mb-3 bg-gray-50 rounded-lg overflow-hidden">
                                                            {widget.id.includes('bar') && (
                                                                <ResponsiveContainer width="100%" height="100%">
                                                                    <BarChart data={previewBarData}>
                                                                        <Bar dataKey="value" fill={colors.icon.replace('bg-', '#').replace('blue-600', '3b82f6').replace('green-600', '10b981').replace('purple-600', '8b5cf6').replace('orange-600', 'f97316').replace('red-600', 'ef4444').replace('yellow-600', 'eab308')} radius={[4, 4, 0, 0]} />
                                                                    </BarChart>
                                                                </ResponsiveContainer>
                                                            )}

                                                            {widget.id.includes('pie') && (
                                                                <ResponsiveContainer width="100%" height="100%">
                                                                    <PieChart>
                                                                        <Pie data={previewPieData} cx="50%" cy="50%" outerRadius={35} dataKey="value">
                                                                            {previewPieData.map((entry, i) => (
                                                                                <Cell key={`cell-${i}`} fill={entry.color} />
                                                                            ))}
                                                                        </Pie>
                                                                    </PieChart>
                                                                </ResponsiveContainer>
                                                            )}

                                                            {widget.id.includes('line') && (
                                                                <ResponsiveContainer width="100%" height="100%">
                                                                    <LineChart data={previewBarData}>
                                                                        <Line type="monotone" dataKey="value" stroke="#8b5cf6" strokeWidth={2} dot={false} />
                                                                    </LineChart>
                                                                </ResponsiveContainer>
                                                            )}

                                                            {!widget.id.includes('bar') && !widget.id.includes('pie') && !widget.id.includes('line') && (
                                                                <div className="w-full h-full flex items-center justify-center">
                                                                    <div className="w-16 h-16 rounded-xl bg-gray-200 flex items-center justify-center">
                                                                        <Icon className="w-8 h-8 text-gray-400" />
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Add/Added Indicator */}
                                                        <div className="flex items-center justify-center">
                                                            {isAdded ? (
                                                                <div className="flex items-center gap-1.5 text-green-600 text-xs">
                                                                    <CheckCircle className="w-4 h-4" />
                                                                    <span>Added</span>
                                                                </div>
                                                            ) : (
                                                                <div className="text-xs text-gray-400">Click to add</div>
                                                            )}
                                                        </div>
                                                    </motion.div>
                                                );
                                            })}
                                        </div>

                                        {searchedWidgets.length === 0 && (
                                            <div className="text-center py-12">
                                                <p className="text-gray-500">No widgets found</p>
                                            </div>
                                        )}
                                    </div>
                                </motion.div>
                            </>
                        )}
                    </AnimatePresence>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
}